"use strict";

import { generalBillPaymentsConstants, commonConstants } from "../_constants";

const getInitialState = () => ({
  payeeCategoriesList: [],
  payeeTypesList: [],
  payableList: [],
  selectedCategory: null,
  selectedPayeeType: null,
  billPaymentScreenType: commonConstants.BILL_PAYEMENT_DASHBOARD_TYPE_SCREEN,
  payableAccounts: [],
  payableCards: [],
  selectedPaymentOption: {},
  payAccountNumber: null,
  cardType: null,
  payBalance: null,
  payeeType: {},
  billAmount: 0,
  billAccountNumber: "",
  billAccountNumberValidation: {},
  outStandingAmount: 0,
  checkAmountValidation: {},
  isOtpProcessRequired: false,
  otpTimerTimePeriod: 0,
  otpExpireTime: 0,
  transactionInfo: {},
  confirmationTransactionInfo: {},
  isBillCategoriesLoading: false,
  payeeCategoriesListLoaded: false,
  isBillPayeeTypesLoading: false,
  isBillPayementValidationLoading: false,
  validateAmountStatus: "",
  payBillErrorStatus: "",
  optFailedError: {},
  optFailedErrorStatus: "",
  reloadBillerCategories: false,
  billerTransactionInitiateData: {},
});

export function generalBillPayements(state = getInitialState(), action) {
  switch (action.type) {
    case generalBillPaymentsConstants.PAYEE_CATEGORIES_LIST_REQUEST:
      return {
        ...state,
        isBillCategoriesLoading: true,
        reloadBillerCategories: false,
      };

    case generalBillPaymentsConstants.PAYEE_CATEGORIES_LIST_COMPLETE:
      return {
        ...state,
        isBillCategoriesLoading: false,
        payeeCategoriesListLoaded: true,
        payeeCategoriesList: action.payload?.data?.billerCategoryList ?? [],
      };

    case generalBillPaymentsConstants.PAYEE_CATEGORIES_LIST_ERROR:
      return {
        ...state,
        payeeCategoriesList: [],
        isBillCategoriesLoading: false,
        payeeCategoriesListLoaded: true,
      };

    case generalBillPaymentsConstants.PAYEE_TYPES_LIST_REQUEST:
      return {
        ...state,
        isBillPayeeTypesLoading: true,
      };
    case generalBillPaymentsConstants.PAYEE_TYPES_LIST_COMPLETE:
      return {
        ...state,
        payeeTypesList: action.payload?.data?.payeeTypeList,
        isBillPayeeTypesLoading: false,
      };

    case generalBillPaymentsConstants.PAYEE_TYPES_LIST_ERROR:
      return {
        ...state,
        payeeTypesList: [],
        isBillPayeeTypesLoading: false,
      };

    case generalBillPaymentsConstants.PAYABLE_LIST_COMPLETE:
      return {
        ...state,
        payableList: action.payload?.data?.accountList,
      };

    case generalBillPaymentsConstants.PAYABLE_LIST_ERROR:
      return {
        ...state,
        payableList: [],
      };

    case generalBillPaymentsConstants.SET_SLECETED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.payload,
      };

    case generalBillPaymentsConstants.SET_SELECTED_PAYEE_TYPE:
      return {
        ...state,
        selectedPayeeType: action.payload,
      };

    case generalBillPaymentsConstants.SET_BILLER_SCREEN_TYPE:
      return {
        ...state,
        billPaymentScreenType: action.payload,
      };
    case generalBillPaymentsConstants.SET_PAYABE_ACCOUNTS:
      return {
        ...state,
        payableAccounts: action.payload,
      };
    case generalBillPaymentsConstants.SET_PAYABE_CARDS:
      return {
        ...state,
        payableCards: action.payload,
      };

    case generalBillPaymentsConstants.SET_SELECTED_PAYMENT_OPTION:
      return {
        ...state,
        selectedPaymentOption: action.payload,
      };
    case generalBillPaymentsConstants.SET_PAY_ACCOUNT_NUMBER:
      return {
        ...state,
        payAccountNumber: action.payload,
      };

    case generalBillPaymentsConstants.SET_CARD_TYPE:
      return {
        ...state,
        cardType: action.payload,
      };

    case generalBillPaymentsConstants.SET_BILL_OUTSTANDING_AMOUNT:
      return {
        ...state,
        outStandingAmount: action.payload,
      };
    case generalBillPaymentsConstants.SET_PAY_BALANCE:
      return {
        ...state,
        payBalance: action.payload,
      };

    case generalBillPaymentsConstants.SET_PAYEE_TYPE:
      return {
        ...state,
        payeeType: action.payload,
      };

    case generalBillPaymentsConstants.SET_BILL_AMOUNT:
      return {
        ...state,
        billAmount: action.payload,
      };

    case generalBillPaymentsConstants.SET_BILL_ACCOUNT_NUMBER:
      return {
        ...state,
        billAccountNumber: action.payload,
      };

    case generalBillPaymentsConstants.VALIDATE_BILL_ACCOUNT_NUMBER_COMPLETE:
      return {
        ...state,
        validateAmountStatus: "",
        billAccountNumberValidation:
          action.payload?.data?.spiderBillerValidateResponse,
      };

    case generalBillPaymentsConstants.VALIDATE_BILL_ACCOUNT_NUMBER_ERROR:
      return {
        ...state,
        validateAmountStatus: action.payload?.response?.statusCode,
        billAccountNumberValidation: {},
      };

    case generalBillPaymentsConstants.VALIDATE_BILL_AMOUNT_REQUEST:
      return {
        ...state,
        isBillPayementValidationLoading: true,
      };
    case generalBillPaymentsConstants.VALIDATE_BILL_AMOUNT_COMPLETE:
      return {
        ...state,
        isBillPayementValidationLoading: false,
        checkAmountValidation: action.payload?.data?.transactionInfo,
        validateAmountStatus: "",
      };

    case generalBillPaymentsConstants.VALIDATE_BILL_AMOUNT_ERROR:
      return {
        ...state,
        isBillPayementValidationLoading: false,
        checkAmountValidation: action.payload?.response?.errorResponse
          ?.transactionInfo
          ? action.payload.response.errorResponse.transactionInfo
          : {},
        validateAmountStatus: action.payload.response.statusCode,
      };

    case generalBillPaymentsConstants.GENERAL_PAY_BILL_REQUEST:
      return {
        ...state,
        transactionInfo: {},
      };

    case generalBillPaymentsConstants.GENERAL_PAY_BILL_COMPLETE:
      return {
        ...state,
        isOtpProcessRequired: action.payload?.data?.isOtpProcessRequired,
        otpTimerTimePeriod: action.payload?.data?.otpTimerTimePeriod,
        otpExpireTime: action.payload?.data?.otpExpireTime,
        transactionInfo: action.payload?.data?.transactionInfo,
      };

    case generalBillPaymentsConstants.GENERAL_PAY_BILL_ERROR:
      return {
        ...state,
        confirmationTransactionInfo:
          action.payload?.response?.errorResponse?.transactionInfo ?? {},
      };

    case generalBillPaymentsConstants.OTP_CONFIRMATION_ERROR:
      return {
        ...state,
        confirmationTransactionInfo:
          action.payload?.response?.errorResponse?.transactionInfo,
        optFailedErrorStatus: action.payload?.response?.statusCode,
        optFailedError: action.payload?.response,
        isOtpProcessRequired: false,
      };

    case generalBillPaymentsConstants.OTP_CONFIRMATION_COMPLETE:
      return {
        ...state,
        confirmationTransactionInfo: action.payload?.data?.transactionInfo,
        optFailedErrorStatus: "",
        optFailedError: {},
        isOtpProcessRequired: false,
      };

    case generalBillPaymentsConstants.BILL_PAYMENTS_OTP_RESEND_COMPLETE:
      return {
        ...state,
        confirmationTransactionInfo: action.payload?.data?.transactionInfo,
      };

    case generalBillPaymentsConstants.BILL_PAYMENTS_OTP_RESEND_ERROR:
      return {
        ...state,
        confirmationTransactionInfo:
          action.payload?.response?.errorResponse?.transactionInfo,
        isOtpProcessRequired: false,
      };
    case generalBillPaymentsConstants.TRY_AGAIN_BILL_PAYMENT:
      return {
        ...state,
        checkAmountValidation: {},
        confirmationTransactionInfo: {},
        transactionInfo: {},
      };
    case generalBillPaymentsConstants.SET_RELOAD_BILLER_CATEGORIES:
      return {
        ...state,
        reloadBillerCategories: action.payload,
      };

    case generalBillPaymentsConstants.SET_BILLER_TRANSACTION_INITIATE_DATA:
      return {
        ...state,
        billerTransactionInitiateData: action.payload,
      };

    case generalBillPaymentsConstants.CLEAR_GENAREL_BILLER:
      return getInitialState();
  }
  return state;
}
